import { TweenMax, Expo } from 'gsap';

/**
 * Opens an element
 *
 * @example
 * import {open} from '../helpers';
 *
 * open($('.element'));
 *
 * @param {Object} el - HTML element you want to target for animation
 * @param {Number} speed - Speed of the animation
 * @param {String} ease - Ease of the animation
 * @param {Function} onComplete - On complete function
 */
export const open = (el, speed = 0.4, ease = 'easeOut', onComplete) => {
  TweenMax.set(el, { height: 'auto' });
  TweenMax.from(el, speed, { height: 0, ease: Expo[ease], onComplete });
};

/**
 * Closes an element
 *
 * @example
 * import {close} from '../helpers';
 *
 * close($('.element'));
 *
 * @param {Object} el - HTML element you want to target for animation
 * @param {Number} speed - Speed of the animation
 * @param {String} ease - Ease of the animation
 * @param {Function} onComplete - On complete function
 */
export const close = (el, speed = 0.4, ease = 'easeOut', onComplete) => {
  TweenMax.to(el, speed, { height: 0, ease: Expo[ease], onComplete });
};

/**
* Scrolls to a certain part of the page with GSAP
*
* @param {Number} y - The new y position
* @param {Number} speed - The spped in which the screen scrolls
* @param {Function} onComplete - On complete function
*/
// export const scrollTo = (y, speed = 1.5, onComplete) => {
//   TweenMax.to(window, speed, { scrollTo: { y }, ease: Expo.easeOut, onComplete });
// };

/**
 * Renders React modules on a page
 *
 * @example
 * import {renderReactModule} from '../helpers';
 *
 * {name: 'bar/SomeComponent',
 *   render(component, el) {
 *     renderReactModule(component, el);
 *   }
 * }
 *
 * @param {Object} component - HTML element you want to target for animation
 * @param {Object} el - HTML element you want to target for animation
 * @param {Object} data - Additional data to be passed in to the React component
 */
export const renderReactModule = (component, el, data) => {
  const length = el.length;
  const React = require('react');
  const ReactDom = require('react-dom');

  for(let i = 0; i < length; i++) {
    ReactDom.render(React.createElement(component, { ...data, ...el[i].dataset }), el[i]);
  }
};
